import { createVNode as _createVNode, isVNode as _isVNode, mergeProps as _mergeProps } from "vue";
import { defineComponent } from 'vue';
import { Button as AntButton } from 'ant-design-vue';
import { buttonProps as antButtonProps } from 'ant-design-vue/es/button/button';
import Wrapper from '../wrapper';
import { commonProps } from '../utils';
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
const elfButtonProps = {
  ...commonProps,
  size: {
    type: String,
    default: 'm'
  }
}; // 这里的as const可以防止在.d.ts中将required:true生成required:boolean，这样的话，可以保证组件prop的required可以被成功校验

const buttonProps = {
  ...antButtonProps(),
  ...elfButtonProps
};
const Button = defineComponent({
  name: 'ElfButton',
  props: buttonProps,
  setup(props, {
    attrs,
    slots
  }) {
    return () => {
      const {
        size
      } = props;
      const newProps = {
        ...props,
        size: undefined // 无视antd自身的size props
      };

      return _createVNode(Wrapper, null, {
        default: () => [_createVNode(AntButton, _mergeProps(newProps, attrs, {
          "class": `elf-btn-${size}`
        }), _isSlot(slots) ? slots : {
          default: () => [slots]
        })]
      });
    };
  }
});
export default Button;